import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { STUDIO_INQUIRY_CONFIRMATION } from '../../constants/common';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-studio-inquiry-confirmation',
    templateUrl: './studio-inquiry-confirmation.component.html',
    styleUrls: ['./studio-inquiry-confirmation.component.scss'],
    standalone: false
})
export class StudioInquiryConfirmationComponent {
  constants = STUDIO_INQUIRY_CONFIRMATION;

  constructor(public activeModal: NgbActiveModal) { }

  /**
   * closeModal() - Closes the inquiry now that it has been sent
   */
  closeModal(): void {
    this.activeModal.close();
  }
}
